import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import About from './views/About.vue'
import Products from './views/Products.vue'
// import Application from './views/StartApplication.vue'
import ContinueApplication from './views/ContinueApplication.vue'
import store from './store.js'
import NotFound from './views/NotFound.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
      // component: () => import(/* webpackChunkName: "home" */ './views/Home.vue')
    },
    {
      path: '/about',
      name: 'about',
      component: About
      // () =>
      //   import(/* webpackChunkName: "about" */ './views/About.vue')
      // // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      // component: () =>
      //   import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/products',
      name: 'products',
      component: Products
      // () =>
      //   import(/* webpackChunkName: "products" */ './views/Products.vue')
    },
    {
      path: '/application',
      name: 'application',
      component: () =>
        import(/* webpackChunkName: "application" */ './views/StartApplication.vue')
    },
    {
      path: '/continue',
      name: 'continue',
      component: ContinueApplication
    },
    {
      path: '*',
      name: '404',
      component: NotFound
    },
    {
      path: '/toSigningApplication',
      beforeEnter() {
        // Put the full page url including the protocol http(s) below
        window.location = store.state.externalRoute
      }
    }
  ]
})

export default router

router.beforeEach((to, from, next) => {
  // console.log(to)

  if (to.query.continue && to.query.continue == 'true') {
    return next({
      path: '/continue'
    })
  }

  return next()

  // const { authorize } = to.meta;

  // Auth.currentAuthenticatedUser()
  //   .then((user) => {
  //     let roles = store.state.userRoles.split(",");

  //     let authorized = false;

  //     for (let role of roles) {
  //       if (authorize.length && authorize.includes(role)) {
  //         authorized = true;
  //       }
  //     }

  //     if (!user || !authorized) {
  //       // role not authorised so redirect to home page
  //       return next({
  //         path: "/notauthorized",
  //         query: {
  //           // login: to.query.login ? to.query.login : "",
  //         },
  //       });
  //     }
  //   })
  //   .catch(() => {
  //     if (authorize && to.path != "/") {
  //       // not logged in so redirect to login page with the return url
  //       // and the login query if it exists:
  //       return next({
  //         path: "/login",
  //         query: {
  //           code: from.query.code ? from.query.code : to.query.code,
  //           unauthorized: from.query.unauthorized
  //             ? from.query.unauthorized
  //             : to.query.unauthorized,
  //         },
  //       });
  //     }
  //   });

  // return next({
  //   query: {
  //     code: from.query.code ? from.query.code : to.query.code,
  //   },
  // });
})
